import { render, staticRenderFns } from "./ContactWidget.vue?vue&type=template&id=d868bb44&scoped=true"
import script from "./ContactWidget.vue?vue&type=script&lang=js"
export * from "./ContactWidget.vue?vue&type=script&lang=js"
import style0 from "./ContactWidget.vue?vue&type=style&index=0&id=d868bb44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d868bb44",
  null
  
)

export default component.exports